<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Customer Tag</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" href="#"
             [class.active]="!creatingNewTag"
             (click)="toggleCreatingNewTag(false);$event.preventDefault()">
            Search Existing Tags
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#"
             [class.active]="creatingNewTag"
             (click)="toggleCreatingNewTag(true);$event.preventDefault()">
            Create New Tag
          </a>
        </li>
      </ul>
    </div>

    <ng-container *ngIf="!creatingNewTag">
      <div class="form-group">
        <label for="tagSearchInput">Tag Name</label>
        <input type="text" class="form-control" id="tagSearchInput" name="tagSearchInput"
               [(ngModel)]="tagSearchInput"
               (ngModelChange)="tagName = ''">
      </div>

      <!-- Add a fixed-height div to prevent the modal from shifting as results are loaded -->
      <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
           *ngIf="tagName === ''">

        <table class="table table-bordered table-hover">
          <tbody>
          <ng-container *ngIf="loadingTags">
            <tr>
              <td>Loading tags...</td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!loadingTags && (tagOptions.length === 0)">
            <tr>
              <td>No existing tags.</td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!loadingTags && (tagOptions.length > 0)">
            <tr *ngFor="let tag of getMatchedTags()"
                class="cursor-pointer"
                (click)="tagSearchInput = tag;tagName = tag;">
              <td>{{ tag }}</td>
            </tr>
            <tr *ngIf="getMatchedTags().length === 0">
              <td>No tags found.</td>
            </tr>
          </ng-container>
          </tbody>
        </table>

      </div>
    </ng-container>

    <form (ngSubmit)="handleSave()" *ngIf="creatingNewTag">
      <div class="form-group">
        <label for="tagInput">Tag Name</label>
        <input type="text" class="form-control" id="tagInput" name="tag"
               [(ngModel)]="tagName">
      </div>
    </form>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            [disabled]="!saveButtonEnabled()"
            [class.disabled]="!saveButtonEnabled()"
            (click)="handleSave()">
      {{ loadingSubmit ? 'Loading...' : 'Save' }}
    </button>
  </div>

</ng-container>
